import { render, staticRenderFns } from "./ProjectListMediacontactMaterialCreate.vue?vue&type=template&id=137b34e2"
import script from "./ProjectListMediacontactMaterialCreate.vue?vue&type=script&lang=js"
export * from "./ProjectListMediacontactMaterialCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports